export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=5"},{"charset":"utf-8"},{"name":"description","content":"meta.description"},{"property":"og:title","content":"meta.title"},{"property":"og:description","content":"meta.description"},{"property":"og:image","content":"https://d1sxh1d27p6t6a.cloudfront.net/v2/uploads/2025/12/02125348/image.png"},{"property":"og:type","content":"website"},{"name":"twitter:title","content":"meta.title"},{"name":"twitter:description","content":"meta.description"},{"name":"twitter:image","content":"https://d1sxh1d27p6t6a.cloudfront.net/v2/uploads/2025/12/02125348/image.png"},{"name":"twitter:card","content":"summary_large_image"},{"name":"theme-color","content":"#ffffff"}],"link":[{"rel":"apple-touch-icon","sizes":"180x180","href":"/50-ftd-20-frl-gllo/apple-touch-icon.png"},{"rel":"shortcut icon","href":"/50-ftd-20-frl-gllo/favicon.ico"},{"rel":"icon","type":"image/svg+xml","href":"/50-ftd-20-frl-gllo/favicon.svg"},{"rel":"icon","type":"image/png","sizes":"96x96","href":"/50-ftd-20-frl-gllo/favicon-96x96.png"},{"rel":"manifest","href":"/50-ftd-20-frl-gllo/site.webmanifest"}],"style":[],"script":[],"noscript":[],"title":"meta.title","viewport":"width=device-width, initial-scale=1, maximum-scale=5","htmlAttrs":{"lang":"en"}}

export const appBaseURL = "/50-ftd-20-frl-gllo/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"